export default __webpack_public_path__ + "static/media/tunning.a1e676d6.png";